<template lang="pug">
  v-layout.box-tarjeta-beneficios-bloqueados(column)
    v-flex.box-banda
      span {{mensajeBanda || '2do año bloqueado'}}
    v-flex.box-title
      span {{titulo || 'Cuota Comodín'}}
    v-flex.box-descripcion
      span {{descripcion|| 'Podrás dejar de pagar una cuota y no preocuparte por el pago hasta el siguiente mes.'}}
</template>

<script>
export default {
  props: [
    'mensajeBanda',
    'titulo',
    'descripcion'
  ]
}
</script>

<style scoped>
.box-tarjeta-beneficios-bloqueados {
  border: 1px solid #C4C4C4;
  border-radius: 18px;
  background: #DFDFDF;
  padding: 1.2em;
  max-width: 367px;
  height: 154px;
  align-items: start;
}

.box-tarjeta-beneficios-bloqueados .box-banda {
  margin-bottom: 0.8em;
  background: #ffffff;
  padding: 0em 0.8em;
  line-height: normal;
  display: flex;
  align-items: center;
  border-radius: 5px;
  max-height: 2em;
}

.box-tarjeta-beneficios-bloqueados .box-banda span {
  font-size: 18px;
  color: #CACACA;
}

.box-tarjeta-beneficios-bloqueados .box-title {
  margin-bottom: 0.5em;
  line-height: normal;
  display: flex;
  align-items: center;
  height: 0em;
}

.box-tarjeta-beneficios-bloqueados .box-title span {
  font-size: 18px;
  color: #FFFFFF;
}

.box-tarjeta-beneficios-bloqueados .box-descripcion {
  text-align: justify;
  line-height: normal;
}

.box-tarjeta-beneficios-bloqueados .box-descripcion span {
  font-size: 16px;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/TarjetaBeneficioBloqueado.vue